export const API_ADDRESS = 'https://api.sinatraology.com/web/api/jazz_vocalists';
//export const API_ADDRESS = 'http://localhost:8080/web/api/jazz_vocalists';
export const PAGE_TITLE_BASE = "Jazz Vocalists UK";
export const API_KEY = "AIzaSyBTndG8XXQ6UI0-S3f2viE-H53g9hwfjcE";